export const selectDatabase = state => state.database?.database
